import React, { useState, useContext, useEffect } from 'react';
import { Checkbox } from '@fluentui/react';
import { Color } from '../../const/Const';
import './Login.css';
import axios from 'axios';
import { baseConfig } from '../../API/APIConfig';
import { UserContext } from '../../context/UserContext';
import { API } from '../../API/API';
import { Col, message, Row } from 'antd';
import { MessageConst } from '../../const/MessageConst';
import CryptoJS from 'crypto-js';
import ButtonLarge from '../../components/ButtonLarge/ButtonLarge';
import FieldTextlarge from '../../components/FieldTextlarge/FieldTextlarge';
import ButtonLargeSecondary from '../../components/ButtonLargeSecondary/ButtonLargeSecondary';
import Warning from '../../components/Warning/Warning';
import ButtonLabel from '../../components/ButtonLabel/ButtonLabel';
import { useNavigate, useSearchParams } from 'react-router-dom';
import FieldText from '../../components/FieldText/FieldText';
import LoadSpin from '../../components/LoadSpin/LoadSpin';
import ButtonDefaultIcon from '../../components/ButtonDefaultIcon/ButtonDefaultIcon';
import FieldNumber from '../../components/FieldNumber/FieldNumber';
import OrgType from '../../components/OrgType/OrgType';
import DiwoLogoWithSign from '../../svg/DiwoLogoWithSign';
import { checkEmail } from '../../SharedFunc/Email';
import { signalrHub } from '../../API/SignalRClient';

const Login = (props) => {

    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    const { setUserInfo } = useContext(UserContext);

    const [initData] = useState(
        {
            "email": null,
            "code": null,
            "newPass": null,
            "newPassRepeat": null,
        }
    );

    const [data, setData] = useState({ ...initData });
    const [username, setUsername] = useState();
    const [password, setPassword] = useState();
    const [regno, setRegno] = useState();
    const [warning, setWarning] = useState();
    const [isPassChange, setIsPassChange] = useState();
    const [isSendMail, setIsSendMail] = useState();
    const [isPassChanged, setIsPassChanged] = useState();
    const [loading, setLoading] = useState(false);
    const [saveusername, setSaveUsername] = useState(false);
    const [pageType, setPageType] = useState();
    const [loadSearch, setLoadSearch] = useState(false);
    const [checkRule, setCheckRule] = useState(false);

    const [signUpData, setSignUpData] = useState({});

    const [emailMessage, setEmailMessage] = useState();

    useEffect(() => {
        let tUsername = localStorage.getItem('username');
        setUsername(tUsername ? tUsername : "");
        let tPageType = searchParams.get("pagetype");
        setPageType(tPageType ? tPageType : "");
    }, [searchParams]);

    const onChangeSaveUsername = (ev, isChecked) => {
        setSaveUsername(isChecked);
    }

    const encrypt = (number) => {
        var key = CryptoJS.enc.Utf8.parse('7061737323313233');
        var iv = CryptoJS.enc.Utf8.parse('7061737323313233');
        var encrypted = CryptoJS.AES.encrypt(
            CryptoJS.enc.Utf8.parse(number),
            key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
            },
        );
        return encrypted.toString();
    }

    const onPressLogin = async () => {
        if (username && password) {

            let vCompanyId = null;
            let vUserId = null;
            if (saveusername) {
                localStorage.setItem('username', username);
            }

            if (username.indexOf('\\') >= 0) {
                vCompanyId = username.split('\\')[0];
                vUserId = username.split('\\')[1];
            } else {
                vUserId = username;
            }

            let respData = {};
            setLoading(true);
            await axios.post('/api/shared/user-management/auth/login', {
                "userid": vUserId,
                "password": encrypt(password),
                "companyid": vCompanyId
            }, {
                baseURL: baseConfig.baseurl,
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(response => {
                if (response?.status === 200 && response?.data) {
                    respData = response?.data;
                } else {
                    setWarning("Нэвтрэх нэр эсвэл нууц үг буруу байна.");
                }
            }).catch(error => {
                setLoading(false);
                if (error?.response?.data?.retmsg) {
                    setWarning(error.response.data.retmsg);
                } else {
                    setWarning(error?.response?.status + ": " + error?.response?.statusText);
                }
            });

            await successLogin(respData, vUserId);

            setLoading(false);

        } else {
            setWarning('Нэвтрэх нэр болон нууц үг оруулна уу.');
        }
    }

    const successLogin = async (respData, vUserId) => {
        if (respData?.accesstoken) {

            localStorage.setItem('userInfo', JSON.stringify({
                ...respData,
                userid: vUserId
            }));

            signalrHub.invoke('AddToGroup', respData.companyid);

            setUserInfo({
                ...respData,
                userid: vUserId
            });
            navigate('/hrsuite/home');
        }
    }

    const onSendMail = async () => {
        let values = { ...data }
        if (values.email) {

            try {
                setLoading(true);
                await API.post('/api/shared/user-management/auth/send-otp', {
                    "email": values.email
                }).then(response => {
                    if (response.status === 200 && response.data?.rettype === 0) {
                        setIsPassChange(true);
                        setIsSendMail(false);
                        setWarning("");
                    }
                }).catch(res => {
                    setWarning(res.response.data.retmsg);
                    setLoading(false);
                });
            } finally {
                setLoading(false);
            }
        }
        else {
            setWarning("Ta и-мэйл хаягаа оруулна уу!");
        }
    }

    const onPassChange = async () => {
        let isValid = true;
        let values = { ...data }
        if (values.newPass !== values.newPassRepeat) {
            isValid = false;
            setWarning("Давтан оруулсан үг нь өөр байна!");
        }
        else if (!values.code) {
            isValid = false;
            setWarning("Баталгаажуулах кодоо оруулна уу!");
        }
        else if (!values.newPass) {
            isValid = false;
            setWarning("Шинэ нууц үгээ оруулна уу!");
        }
        else if (!values.newPassRepeat) {
            isValid = false;
            setWarning("Шинэ нууц үгээ давтан оруулна уу!");
        }
        if (isValid) {
            let param = {
                "email": values.email,
                "code": values.code,
                "password": values.newPass
            }
            setLoading(true);
            await API.post('/api/shared/user-management/auth/reset-pwd', param).then(response => {
                if (response.status === 200 && response.data?.rettype === 0) {
                    message.success(MessageConst.success);
                    setWarning("");
                    setIsPassChange(false);
                    setIsPassChanged(true);
                }
            }).catch(res => {
                setWarning(res.response.data.retmsg);
                setLoading(false);
            });
            setLoading(false);
        }
    }

    const fieldOnChanged = async (key, text, field, email) => {
        if (field) {
            let tData = { ...data };
            tData[field] = key;
            setData(tData);
            if (field === "username") {
                setUsername(key);
            }
            else if (field === "password") {
                setPassword(key);
            } else if (field === "regno") {
                setRegno(key);
            }
        }
    }

    const onBack = (key) => {

        setData(initData);
        setWarning("");

        if (key === "send") {
            setIsSendMail(false);
        }
        else if (key === "change") {
            setIsPassChange(false);
        }
        else if (key == "changed") {
            setIsPassChanged(false);
        }
    }

    const onSearchReg = async () => {
        let tSignUpData = {};
        setWarning();
        setCheckRule(false);
        if (regno) {
            setLoadSearch(true);
            await API.get("/api/shared/user-management/company?registerNo=" + regno, { ignoreRetType: true }).then(response => {
                if (response?.data?.rettype == 0 && response.data?.retdata?.info?.regno) {
                    tSignUpData = response.data?.retdata?.info;
                    tSignUpData.director = tSignUpData?.ceolastname + " " + tSignUpData?.ceofirstname;
                    tSignUpData.registerno = tSignUpData.regno;
                } else {
                    setWarning(response?.data?.retmsg);
                }
            }).catch(response => {
                setLoadSearch(false);
                setWarning("Регистрийн дугаар олдсонгүй");
            });
            setLoadSearch(false);
        } else {
            setWarning("Регистрийн дугаар оруулна уу!");
        }
        setSignUpData(tSignUpData);
    }


    const fieldOnChangedReg = async (key, text, field, fieldname) => {
        if (field) {
            let tSignUpData = { ...signUpData };
            tSignUpData[field] = key;
            setSignUpData(tSignUpData);
        }
    }

    const onNavSignUp = () => {
        setSignUpData({});
        setRegno();
        setSearchParams({
            pagetype: "signup"
        });
    }

    const onNavLogin = () => {
        setSearchParams({
            pagetype: ""
        });
    }

    const onContinue = async () => {
        setCheckRule(true);
        setEmailMessage();

        let tRule = true;
        let vSuccess = false;

        let tSignUpData = { ...signUpData };

        if (!tSignUpData?.email
            || !tSignUpData.phone) {
            tRule = false;
        }

        if (tSignUpData?.email) {
            if (!checkEmail(tSignUpData?.email)) {
                setEmailMessage("Имэйл буруу байна");
                tRule = false;
            }
        }

        if (tRule) {
            try {
                setLoading(true);
                await API.post("/api/shared/user-management/company/initiateregister_v2",
                    tSignUpData).then(response => {
                        if (response?.data?.rettype == 0) {
                            if (response?.data.retdata?.accesstoken) {
                                tSignUpData.accesstoken = response?.data.retdata?.accesstoken;
                                vSuccess = true;
                            }
                        }
                    });
            } finally {
                setLoading(false);
            }

            if (vSuccess) {
                setSignUpData(tSignUpData);
                setSearchParams({
                    pagetype: "confirm"
                });
            }
        }
    }

    const onFinish = async () => {
        setWarning();
        if (signUpData?.accesstoken) {
            if (signUpData?.password && signUpData?.repassword) {
                if (signUpData?.password == signUpData?.repassword) {
                    setLoading(true);
                    try {
                        let respData = {};
                        await API.post("/api/shared/user-management/company/verify_v2", signUpData, {
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${signUpData?.accesstoken}`,
                            },
                            showRetMsg: true
                        }).then(response => {
                            if (response?.status == 200 && response?.data) {
                                respData = response?.data;
                            }
                        });

                        await successLogin(respData, signUpData?.registerno);

                    } finally {
                        setLoading(false);
                    }
                } else {
                    setWarning("Нууц үг таарахгүй байна!");
                }
            } else {
                setWarning("Нууц үг оруулна уу!");
            }
        }
    }

    let viewScreen;

    if (pageType == "confirm") {
        viewScreen = (
            <div className='loginContainer'>
                <div className='loginContPage'>
                    <div style={{ fontWeight: 600, fontSize: 28 }}>Шинэ нууц үгээ оруулна уу</div>
                    <div style={{ marginTop: 32 }}>
                        <div style={{ marginTop: 12 }}>
                            <FieldTextlarge type='password' title="Нууц үг" required onChanged={fieldOnChangedReg} keyfield='password' onEnterClicked={onFinish} />
                        </div>
                        <div style={{ marginTop: 32 }}>
                            <div style={{ marginTop: 12 }}>
                                <FieldTextlarge type='password' title="Нууц үг дахин оруулах" required onChanged={fieldOnChangedReg} keyfield='repassword' onEnterClicked={onFinish} />
                            </div>
                        </div>
                        <div style={{ marginTop: 10 }}>
                            {warning &&
                                <Warning zeroMargin value={warning} />
                            }
                        </div>
                        <div style={{ marginTop: 20 }}>
                            <ButtonLarge loading={loading} onClick={onFinish} text="Нэвтрэх" />
                        </div>
                    </div>
                </div>
            </div>
        )
    } else if (pageType == "signup") {
        viewScreen = (
            <div className='loginContainer'>
                <div className='loginContPage'>
                    <div style={{ fontWeight: 600, fontSize: 32 }}>Бүртгүүлэх</div>
                    <div>
                        <div style={{ marginTop: 24 }}>
                            <Row>
                                <Col span={16}>
                                    <FieldText title="Байгууллагын регистр" required onChanged={fieldOnChanged} keyfield='regno' onEnterClicked={onSearchReg} defaultValue={regno} />
                                </Col>
                                <Col span={8}>
                                    <div style={{ marginLeft: 16 }}>
                                        <div style={{ fontSize: 14 }}>&nbsp;</div>
                                        <div style={{ marginTop: 6 }}>
                                            {loadSearch ? (
                                                <LoadSpin />
                                            ) : (
                                                <ButtonDefaultIcon full iconName="search" text="Хайх" onClick={onSearchReg} />
                                            )}
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div>
                            <Warning value={warning} />
                        </div>
                        <div style={{ marginTop: 13 }}>
                            <FieldText disable={true} onChanged={() => { }} title="Нэр" keyfield="name" defaultValue={signUpData.name} />
                        </div>
                        <div style={{ marginTop: 13 }}>
                            <FieldText disable={true} onChanged={() => { }} title="Хаяг" keyfield="address" defaultValue={signUpData.address} />
                        </div>
                        <div style={{ marginTop: 13 }}>
                            <FieldText disable={true} onChanged={() => { }} title="Гүйцэтгэх захирал" keyfield="director" defaultValue={signUpData.director} />
                        </div>
                        <div style={{ padding: 16, border: '1px solid #DDDDDD', marginTop: 32, borderRadius: 16 }}>
                            <div style={{ marginTop: -28, background: '#FFFFFF', width: 180, textAlign: 'center' }}>Таны имэйл болон утас</div>
                            <div style={{ marginTop: 13 }}>
                                <FieldText disable={signUpData?.regno ? false : true} required onChanged={fieldOnChangedReg} title="Имэйл" keyfield="email" defaultValue={signUpData.email} checkreq={checkRule} message={emailMessage} />
                            </div>
                            <div style={{ marginTop: 13 }}>
                                <FieldNumber disabled={signUpData?.regno ? false : true} required onChanged={fieldOnChangedReg} title="Утас" keyfield="phone" defaultValue={signUpData.phone} checkreq={checkRule} />
                            </div>
                        </div>

                        {signUpData?.regno && (
                            <div>
                                <div style={{ marginTop: 20 }}>
                                    {loading ? <LoadSpin /> : <ButtonLarge onClick={onContinue} text="Үргэлжлүүлэх" />}
                                </div>
                                <div style={{ marginTop: 16, display: 'flex', justifyContent: 'center' }}>
                                    <div onClick={onNavLogin} style={{ color: Color.blue, cursor: 'pointer', fontSize: 14 }}>Бүртгэлтэй хэрэглэгч</div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    } else if (!isSendMail && !isPassChange && !isPassChanged) {
        viewScreen = (
            <div className='loginContainer'>
                <div className='loginContPage'>
                    <div style={{ fontWeight: 600, fontSize: 32 }}>Нэвтрэх</div>
                    <div style={{ marginTop: 32 }}>
                        <div style={{ marginTop: 12 }}>
                            <FieldTextlarge title="Нэвтрэх нэр" required onChanged={fieldOnChanged} keyfield='username'
                                onEnterClicked={onPressLogin} defaultValue={username} />
                        </div>
                        <div style={{ marginTop: 32 }}>
                            <div style={{ marginTop: 12 }}>
                                <FieldTextlarge type='password' title="Нууц үг" required onChanged={fieldOnChanged} keyfield='password'
                                    onEnterClicked={onPressLogin} />
                            </div>
                        </div>
                        <div style={{ marginTop: 30, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ marginTop: 3 }}>
                                    <Checkbox onChange={onChangeSaveUsername} />
                                </div>
                                <div style={{ marginLeft: 6, fontWeight: 600, fontSize: 16 }}>Нэвтрэх нэр сануулах</div>
                            </div>
                            <div style={{
                                fontSize: 16,
                                color: Color.graySecond
                            }}>
                                <ButtonLabel text="Нууц үг мартсан." onClick={() => { setIsSendMail(true); }} />
                            </div>
                        </div>
                        <div style={{ marginTop: 10 }}>
                            {warning &&
                                <Warning zeroMargin value={warning} />
                            }
                        </div>
                        <div style={{ marginTop: 20 }}>
                            <ButtonLarge loading={loading} onClick={onPressLogin} text="Нэвтрэх" />
                        </div>
                    </div>
                    <div style={{ marginTop: 16, display: 'flex', justifyContent: 'center' }}>
                        <div onClick={onNavSignUp} style={{ color: Color.blue, cursor: 'pointer', fontSize: 14 }}>Бүртгүүлэх</div>
                    </div>
                </div>
            </div>
        )
    }
    else if (isSendMail && !isPassChange && !isPassChanged) {
        viewScreen = (<div className='loginContainer'>
            <div className='loginContPage'>
                <div style={{ marginTop: 32 }}>
                    <div style={{ marginTop: 12 }}>
                        <FieldTextlarge title="Бүртгэлтэй и-мэйл хаягаа оруулна уу." required onChanged={fieldOnChanged} keyfield='email' defaultValue={data.email}
                            onEnterClicked={onSendMail} />
                    </div>
                    <div style={{ marginTop: 10 }}>
                        {warning &&
                            <Warning zeroMargin value={warning} />
                        }
                        <div style={{ marginTop: 30 }}>
                            <ButtonLarge loading={loading} text="Илгээх" onClick={onSendMail} />
                        </div>
                        <div style={{ marginTop: 10 }}>
                            <ButtonLargeSecondary text="Буцах" onClick={() => onBack("send")} />
                        </div>

                    </div>
                </div>
            </div>
        </div>)
    }
    else if (!isSendMail && !isPassChanged && isPassChange) {
        viewScreen = (
            <div className='loginContainer'>
                <div className='loginContPage'>
                    <div style={{ fontSize: 16, color: Color.gray }}>Таны <span style={{ color: Color.blue, textDecoration: 'underline', cursor: 'pointer' }}> {data.email} </span> хаяг руу баталгаажуулах код илгээсэн. Та и-мэйл хаягаа шалгаад, ирсэн кодыг Баталгаажуулах код хэсэгт оруулна уу. </div>
                    <div style={{ marginTop: 30 }}>
                        <div style={{ marginTop: 12 }}>
                            <FieldTextlarge required onChanged={fieldOnChanged} title="Баталгаажуулах код" keyfield='code' defaultValue={data.code} autoComplete="new-password" />
                        </div>
                        <div style={{ marginTop: 12 }}>
                            <FieldTextlarge required onChanged={fieldOnChanged} type='password' title="Шинэ нууц үг" keyfield='newPass' defaultValue={data.newPass} autoComplete="new-password" />
                        </div>
                        <div style={{ marginTop: 12 }}>
                            <FieldTextlarge required type='password' onChanged={fieldOnChanged} title="Давтан оруулах" keyfield='newPassRepeat' defaultValue={data.newPassRepeat} autoComplete="new-password" />
                        </div>
                        <div style={{ marginTop: 12 }}>
                            {warning &&
                                <Warning zeroMargin value={warning} />
                            }
                        </div>
                        <div style={{ marginTop: 20 }}>
                            <ButtonLarge loading={loading} text="Илгээх" onClick={onPassChange} />
                        </div>
                        <div style={{ marginTop: 20 }}>
                            <ButtonLargeSecondary text="Буцах" onClick={() => onBack("change")} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    else if (!isSendMail && !isPassChange && isPassChanged) {
        viewScreen = (
            <div className='loginContainer'>
                <div className='loginContPage'>
                    <div style={{ fontSize: 16, color: Color.gray }}>Нууц үг шинэчлэгдлээ. Та <span onClick={() => onBack("changed")} style={{ color: Color.blue, textDecoration: 'underline', cursor: 'pointer' }}> энд дарж </span> нэвтэрнэ үү.</div>
                    <div style={{ marginTop: 20 }}>
                        <ButtonLargeSecondary text="Буцах" onClick={() => onBack("changed")} />
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className='loginPanel'>
            <div className='loginLogo'>
                <div style={{ width: 262, height: 109 }}>
                    <DiwoLogoWithSign />
                </div>
            </div>
            {viewScreen}
        </div>
    );
}

export default Login;